import './index_web.css';
import { View, Text } from '../../../component';
import { useDispatch } from 'react-redux';
import { useState } from 'react';
import useTheme from '../../../utilities/hooks/theme';
import useGame from '../../../utilities/hooks/game';
import Constants from '../../../constants';
import Button from '@mui/material/Button/Button';
import I18t from '../../../utilities/locale';
import React from 'react';
import { createDeepObject } from '../../../utilities/helper';
import { Modal } from '@mui/material';
import constants from '../../../constants';

interface FilterSubItemProps {
  item: any;
  key: any;
  onPressFilter: any;
  theme: any;
}

const FilterSubItem = ({ item, onPressFilter, theme }: FilterSubItemProps) => {
  const { title = '', isSelected = false } = item;

  const subItemContainer = {
    borderColor: isSelected ? 'transparent' : theme.contestFilterSubItemBorder,
    backgroundColor: isSelected ? theme.contestFilterSubItemActive : 'transparent'
  };
  const titleColor = {
    color: isSelected ? 'black' : 'white'
  };

  return (
    <View
      className={'contest-filter-sub-item-wrapper'}
      style={subItemContainer}
      onPress={onPressFilter}>
      <Text className={'contest-filter-sub-item-title'} style={titleColor}>
        {title}
      </Text>
    </View>
  );
};

interface FilterItemProps {
  listItem: any;
  key: any;
  onPressFilter: any;
  theme: any;
  listItemIndex: any;
}

const FilterItem = ({ listItem, onPressFilter, theme }: FilterItemProps) => {
  const { list = [] } = listItem;
  const itemTitle = {
    color: theme.contestFilterItemTitle
  };
  const divider = {
    backgroundColor: theme.contestFilterDivider
  };
  return (
    <View className={'contest-filter-item-wrapper'}>
      <Text className={'contest-filter-item-title'} style={itemTitle}>
        {listItem.title}
      </Text>
      <View className={'contest-filter-sub-item-container'}>
        {list.map((item: any, index: any) => {
          return (
            <FilterSubItem
              item={item}
              key={index}
              theme={theme}
              onPressFilter={() => {
                onPressFilter(index);
              }}
            />
          );
        })}
      </View>
      <View className={'contest-filter-divider'} style={divider} />
    </View>
  );
};

interface Props {
  visible: boolean;
  onPressDismiss?: () => void;
  onApplyFilter: any;
  onClearFilter: any;
}
const ContestFilter = ({ visible, onPressDismiss, onApplyFilter, onClearFilter }: Props) => {
  const { FantasyTheme: theme } = useTheme();
  const { updateContestFilter, contestFilter: contestFilterList } = useGame();

  const dispatch = useDispatch();
  const [selected, setSelected] = useState(false);

  const onPressFilter = (itemIndex: any, subItemIndex: any) => {
    contestFilterList[itemIndex].list[subItemIndex].isSelected =
      !contestFilterList[itemIndex].list[subItemIndex].isSelected;
    dispatch(updateContestFilter(contestFilterList));
    setSelected(!selected);
  };

  const filterWrapper = {
    background: theme.contestFilterContainer
  };

  const buttonApply = {
    width: '120px',
    backgroundColor: '#ffc400',
    color: 'black',
    marginLeft: '10px',
    fontFamily: 'Poppins',
    fontWeight: 600
  };

  const buttonClear = {
    marginLeft: '10px',
    width: '120px',
    backgroundColor: 'transparent',
    color: theme.contestFilterClearBtnBorder,
    fontFamily: 'Poppins',
    fontWeight: 600,
    border: `1px solid ${theme.contestFilterClearBtnBorder}`
  };

  const onPressClear = () => {
    dispatch(updateContestFilter(createDeepObject(Constants.ContestListFilter)));
    setSelected(!selected);
    onClearFilter();
  };
  const divider = {
    backgroundColor: theme.contestFilterDivider
  };

  return (
    <Modal open={visible} onClose={onPressDismiss}>
      <View className={'contest-filter-container'} style={filterWrapper}>
        <View className={'add-cash-modal-header'}>
          <View
            style={{ position: 'absolute', right: '10px', top: '5px' }}
            onPress={onPressDismiss}>
            <img src={constants.Images.closeDark} width="20px" />
          </View>
          <Text className={'add-cash-modal-title'}>Filter</Text>
        </View>
        <View className={'contest-filter-divider'} style={divider} />

        {contestFilterList.map((item: any, index: any) => {
          return (
            <FilterItem
              listItem={item}
              key={index}
              listItemIndex={index}
              onPressFilter={(subItemIndex: any) => {
                onPressFilter(index, subItemIndex);
              }}
              theme={theme}
            />
          );
        })}
        <View className={'contest-filter-button-container'}>
          <Button className="contest-filter-btn-title" style={buttonClear} onClick={onPressClear}>
            {I18t.t('clear')}
          </Button>
          <Button className="contest-filter-btn-title" style={buttonApply} onClick={onApplyFilter}>
            {I18t.t('Apply')}
          </Button>
        </View>
      </View>
    </Modal>
  );
};
export default React.memo(ContestFilter);
